import styled from 'styled-components';

import { TAG_SIZES, TagGroup } from 'ui/tags';
import { colors } from 'ui/theme';

import { Campaign } from '../../../../../domain';
import { IdDisplay } from './IdDisplay';
import { NameLabel } from './NameLabel';
import { useEventHistoryQueryContext } from '../../../contexts/EventHistoryQueryContext';

interface CampaignDetailsProps {
  campaign: Campaign;
}

const HiddenCampaignNameLabel = styled.span`
  color: ${colors.textPrimary};
`;

const StyledTagGroup = styled(TagGroup)`
  div:first-child {
    margin-left: 0;
  }
`;

/**
 * Renders a link to the campaign that is linked to the event, if the campaign is a hidden campaign for Double Opt-In we render only text
 */
export const CampaignDetails = ({ campaign }: CampaignDetailsProps) => {
  const { labelIds = [] } = campaign;
  const { campaignLabelsLookup } = useEventHistoryQueryContext();
  return (
    <div data-test="event-history-campaign">
      {campaign.isHidden ? (
        <HiddenCampaignNameLabel>{campaign.name}</HiddenCampaignNameLabel>
      ) : (
        <NameLabel href={`/campaigns/${campaign.id}`}>{campaign.name}</NameLabel>
      )}
      <IdDisplay id={campaign.id} />
      {!!labelIds?.length && (
        <StyledTagGroup
          value={labelIds.map((label) => campaignLabelsLookup[label])}
          tagSize={TAG_SIZES.SMALL}
          maxTags={2}
        />
      )}
    </div>
  );
};
